import React from 'react';
import { Link } from 'react-router-dom';

export function ExperienceSection() {
  return (
    <section className="py-20 bg-[#2a1114]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <img 
            src="https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/TEZHLY%20(19).png" 
            alt="explore our private job board to gain experience" 
            className="h-25 sm:h-40 mx-auto"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          <div className="relative transform rotate-[-8deg]">
            <img 
              src="https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/IMG_4014.jpg"
              alt="Internship opportunity"
              className="w-full h-48 sm:h-64 object-cover rounded-md shadow-lg border-2 border-white"
            />
            <div className="absolute -bottom-4 -right-4 bg-[#081b1e] px-4 py-2 transform rotate-12">
              <span className="text-white font-bold">Internships</span>
            </div>
          </div>
          <div className="relative transform rotate-[4deg]">
            <img 
              src="https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/IMG_7765%20(1).jpg"
              alt="Networking event"
              className="w-full h-64 object-cover rounded-md shadow-lg border-2 border-white"
            />
          </div>
          <div className="relative transform rotate-[-4deg]">
            <img 
              src="https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/IMG_4017.jpg"
              alt="Remote work"
              className="w-full h-64 object-cover rounded-md shadow-lg border-2 border-white"
            />
            <div className="absolute -top-4 -right-4 bg-[#081b1e] px-4 py-2 transform -rotate-12">
              <span className="text-white font-bold">Full-time Roles</span>
            </div>
          </div>
        </div>

        <div className="text-center">
          <Link 
            to="/jobs"
            className="inline-block px-8 py-3 bg-white text-[#2a1114] hover:opacity-90 transition-opacity text-xl"
            style={{ fontFamily: 'Times New Roman' }}
          >
            View Opportunities
          </Link>
        </div>
      </div>
    </section>
  );
}